import React, { Component } from "react";
import {  Loader, Icon, Message, Tab, Header, Form, Table, Select, Input, Dropdown, List, Button, Modal, Divider, Checkbox} from 'semantic-ui-react'
import { invokeApig, downloadS3Text, uploadS3Text } from "../libs/awsLib";
import config from "../config";

import SmartOrchestrationDefinition from "./SmartOrchestrationDefinition";
import _ from 'lodash';

export default class SmartOrchestrationDefinitions extends Component {
  constructor(props) {
    super(props);




    this.state={orchestrationDefinitions: {}, tabIndex: 0, uploadSuccess: false, uploadFailed: false, showAddNewModal: false, newOrchestrationName: null, configToCopy: 'blank', loading: true};

  }


  
  componentDidMount ()
  {
    this.loadContent();
  }
  // loadOrchestrationDefinitions = () => {invokeApig({path: "/lookups/orchestrations", method: "GET",  body: null}).then((result)=>{ this.setState({orchestrationDefinitions: result.data, loading: false} )}).catch((err)=>{console.log(err)})}


  loadContent()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/smartorchestrations.json'
    downloadS3Text(bucket, key).then(result=>{console.log(result); this.setState({orchestrationDefinitions: result, loading: false})})
  }
  saveContent()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/smartorchestrations.json'
    //update json 
    uploadS3Text(bucket, key, this.state.orchestrationDefinitions).then(result=>{this.setState({uploadSuccess: true, uploadFailed: false, validationErrors: []})}).catch(result=>{this.setState({uploadSuccess: false, uploadFailed: true, validationErrors: ['Failed to save Orchestration Definitions file']})})
  }

  closeAddNewModal=()=>
  {
    this.setState({showAddNewModal: false, configToCopy: null, newOrchestrationName: null})
  }
 

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }


  addNewOrchestrationDefinition()
  {
    //check the name is different
    if (this.state.newOrchestrationName !== null && this.state.newOrchestrationName !== "")
        {
          if (this.state.newOrchestrationName in this.state.orchestrationDefinitions)
            alert("Orchestration Definition name already exists")
        else {
          // if select (dropdown) is not blank/create blank
          if (this.state.configToCopy === null)
          alert("Create a new configuration or select an existing configuration to use as a template")
          else {
            var copyData=_.cloneDeep(this.state.orchestrationDefinitions);
            if (this.state.configToCopy === 'blank'){
                copyData[this.state.newOrchestrationName]={description: '', datarequirements: {}, startsteps: ['1'], steps: [] }
              }
            else
            {
              // copy data from the selected policy

              var copyConfig=this.state.orchestrationDefinitions[this.state.configToCopy];
              copyData[this.state.newOrchestrationName]=_.cloneDeep(copyConfig);
;
            }
            this.setState({orchestrationDefinitions: copyData})
            this.closeAddNewModal()
          }
        }
         }
    else alert("Please provide a Orchestration Definition name")

  }

  updateOrchestrationDefinition(orchestrationName, data) {
    var copyData=_.cloneDeep(this.state.orchestrationDefinitions);
    copyData[orchestrationName]=data;
    this.setState({orchestrationDefinitions: copyData});
  }

 render() {
  const handleTabChange=(e, data)=>
  {

    //handle add new click
    if (data.activeIndex===Object.keys(this.state.orchestrationDefinitions).length)
    {
      this.setState({showAddNewModal: true})
    }
    this.setState({tabIndex: data.activeIndex})
  }

        var orchestrationDefinitions=[{key: 0, text: 'New Orchestration', value: 'blank'}]
        Object.keys(this.state.orchestrationDefinitions).forEach((orchestrationDefinition, i)=>orchestrationDefinitions.push({key: i+1, text: orchestrationDefinition, value: orchestrationDefinition}))
     
        const panes = Object.keys(this.state.orchestrationDefinitions).map(orchestrationDefinitionName=>{
          var orchestrationDefinition=this.state.orchestrationDefinitions[orchestrationDefinitionName];
          return { menuItem: {key: orchestrationDefinitionName, content: orchestrationDefinitionName, icon: 'cogs'}, render: () => <Tab.Pane>
        <div>
    <SmartOrchestrationDefinition name={orchestrationDefinitionName} data={orchestrationDefinition} editmode={true} onDataChange={newData=>{this.updateOrchestrationDefinition(orchestrationDefinitionName, newData)}} darkmode={this.props.darkmode}/>
        </div>
        </Tab.Pane> }
        });
      panes.push({ menuItem: {key: "Add", content: "Add New", icon: 'add'}, render: ()=><Tab.Pane></Tab.Pane>})
      if (this.state.loading)
        return <Loader/>
      else       return (
      <div className="fullpagetab">
      <div>
      <Tab  grid= {{paneWidth: 13, tabWidth: 3}} menu={{tabular: false, fluid: true, vertical: true, className: this.props.darkmode ? "seaglassblueinverted-darkmode viewtabmenu" : "seaglassblueinverted viewtabmenu", inverted: true }} activeIndex={this.state.tabIndex} panes={panes} onTabChange={handleTabChange} />
      </div>
      {this.state.uploadFailed && <Message error header="Failed to save orchestration definitions" list={this.state.validationErrors}/>}
      {this.state.uploadSuccess && <Message success header="Orchestration definitions successfully saved"/>}
      <Modal open={this.state.showAddNewModal}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="add" onClick={this.addNewPolicy}/>Add New Orchestration Definition</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Form.Input
          id="newOrchestrationName"
          label="Orchestration Definition Name"
          fluid
          required
          placeholder='Orchestration Definition Name'
          value={this.state.newOrchestrationName}
          onChange={this.handleChange}
        />
        <Form.Select label="Orchestration Definition to Copy" placeholder="Orchestration Definition to Copy" required options={orchestrationDefinitions} onChange={(event, data)=>{this.setState({configToCopy: data.value})}}></Form.Select>
        <Divider/>
        {this.state.components && <Button className="seaglassbutton" disabled={!this.state.formValid || this.state.submitSuccess} loading={this.state.isExecuting} onClick={this.executeFunction}>Save</Button>}
        <Button className='seaglassbutton' onClick={()=>this.addNewOrchestrationDefinition()}>Add</Button>
        <Button className="seaglassbutton" onClick={this.closeAddNewModal}>Close</Button>
        </Form>
        </Modal.Content>
        </Modal>   
      <div>
      <Divider/>
      <Button className='seaglassbutton' onClick={()=>this.saveContent()}>Save</Button>
      <Button className='seaglassbutton' onClick={()=>this.loadContent()}>Reset</Button>
      </div>
      </div>
    
    );  

  
    }
  }